<!-- mettal-3\src\components\Task.vue -->
<template>
  <div :class="[`task-2`, className || ``]">
    <img
      class="vector-183"
      src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/vector-579.svg"
      alt="Vector"
    />
    <img
      class="vector-184"
      src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/vector-580.svg"
      alt="Vector"
    />
    <img
      class="vector-186"
      src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/vector-581.svg"
      alt="Vector"
    />
    <img
      class="vector-187"
      src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/vector-582.svg"
      alt="Vector"
    />
    <img
      class="vector-188"
      src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/vector-583.svg"
      alt="Vector"
    />
    <img
      class="vector-189"
      src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/vector-584.svg"
      alt="Vector"
    />
  </div>
</template>

<script>
export default {
  name: "Task",
  props: ["className"],
};
</script>

<style>
.task-2 {
  aspect-ratio: 1.06;
  height: 78.7%;
  left: 0;
  position: absolute;
  top: 10%;
  width: 19.38%;
}

.vector-183 {
  height: 12.71%;
  left: 38.45%;
  position: absolute;
  top: 87.77%;
  width: 67.54%;
}

.vector-184 {
  height: 12.71%;
  left: 38.45%;
  position: absolute;
  top: 46.59%;
  width: 67.54%;
}

.vector-186 {
  height: 12.71%;
  left: 38.45%;
  position: absolute;
  top: 5.41%;
  width: 67.54%;
}

.vector-187 {
  height: 30.35%;
  left: -6%;
  position: absolute;
  top: -6.35%;
  width: 34.22%;
}

.vector-188 {
  height: 30.35%;
  left: -6%;
  position: absolute;
  top: 34.83%;
  width: 34.22%;
}

.vector-189 {
  height: 30.35%;
  left: -6%;
  position: absolute;
  top: 76%;
  width: 34.22%;
}

.task-2.task-3 {
  height: 78.71%;
}

.task-2.task-3 .vector-183,
.task-2.task-4 .vector-183 {
  top: 87.76%;
}

.task-2.task-3 .vector-188,
.task-2.task-4 .vector-188 {
  top: 34.82%;
}

.task-2.task-4 {
  height: 78.71%;
  width: 18.52%;
}
</style>
